import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
  model,
} from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import {
  FileUploaderComponent,
  FormFieldComponent,
  FormTextareaComponent,
  TimepickerComponent,
} from '@pishgamrayan/ng-form-kit';

import {
  FormBuilderFieldResponseModel,
  FormBuilderFieldTypes,
  GetFormBuilderByIdFieldDto,
} from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { LoggerService } from 'src/app/core/services/logger.service';
import { DatepickerComponent } from 'src/app/shared/components/form-kit/datepicker/datepicker.component';
import { CustomSelectSearchComponent } from 'src/app/shared/components/select-search/custom-select-search.component';
import { ShowImagesModule } from 'src/app/shared/components/show-images/show-images.module';

@Component({
  selector: 'form-generator-field',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    FormFieldComponent,
    DatepickerComponent,
    TimepickerComponent,
    FormTextareaComponent,
    FileUploaderComponent,
    CustomSelectSearchComponent,
    MatSlideToggle,
    ShowImagesModule,
    MatMenuModule,
    MatTooltipModule,
  ],
  templateUrl: './form-generator-field.component.html',
  styles: [
    `
      ::ng-deep .mat-mdc-menu-content {
        padding: 15px !important;
      }
    `,
  ],
})
export class FormGeneratorFieldComponent {
  loggerService = inject(LoggerService);
  tagName: string = 'form-generator-field';

  @Input() responses: FormBuilderFieldResponseModel[] = [];
  fieldValue = model.required<GetFormBuilderByIdFieldDto>();

  imageUrl: any;
  selectListOptions: { id: number; value: string }[];
  @Output() finalModel = new EventEmitter<FormBuilderFieldResponseModel[]>();

  get formBuilderFieldTypes() {
    return FormBuilderFieldTypes;
  }

  constructor() {}

  ngOnInit(): void {
    if (this.fieldValue().fieldType == FormBuilderFieldTypes.SelectList) {
      this.selectListOptions = this.fieldValue().selectListOptions.map(
        (value, index) => ({
          id: index + 1,
          value,
        })
      );
    }
  }

  onChangeData(key, value, isDateType: boolean = false) {
    let item = this.responses?.find((res) => res.formBuilderFieldId == key);
    if (value) {
      let response: FormBuilderFieldResponseModel = {
        formBuilderFieldId: key,
        response: isDateType
          ? DateTimeService.toUTC(value)?.split('T')[0]
          : value,
      };
      if (item)
        item.response = isDateType
          ? DateTimeService.toUTC(value)?.split('T')[0]
          : value;
      else this.responses.push(response);
    } else {
      if (item) {
        this.responses = this.responses.filter(
          (item) => item.formBuilderFieldId !== key
        );
      }
    }
    this.emitFinalModel();
  }

  emitFinalModel() {
    this.finalModel.emit(this.responses);
  }

  //#region file

  getFile(formBuilderFieldId, file) {
    try {
      if (!file) {
        return;
      }
      this.onFileChanged(formBuilderFieldId, file);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.dashboard);
    }
  }

  onFileChanged(formBuilderFieldId, file: any) {
    try {
      if (file && file) {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.imageUrl = event.target.result;
        };

        reader.readAsDataURL(file);
        this.handleFileSelect(formBuilderFieldId, file);
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.dashboard);
    }
  }

  handleFileSelect(formBuilderFieldId, evt) {
    try {
      const files = evt;
      const file = files;

      if (files && file) {
        const reader = new FileReader();

        reader.onload = this._handleReaderLoaded.bind(formBuilderFieldId, this);

        reader.readAsBinaryString(file);
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.dashboard);
    }
  }

  _handleReaderLoaded(formBuilderFieldId, readerEvt) {
    try {
      const binaryString = readerEvt.target.result;
      let stringImage = btoa(binaryString);
      // this.model.chequeImageAddress = stringImage;
      this.onChangeData(formBuilderFieldId, stringImage);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.dashboard);
    }
  }

  //#endregion
}
